import React, {useEffect, useState} from 'react';
import OnboardInput from "../../component/base/onboard-input/OnboardInput";
import OnboardButton from "../../component/base/onboard-button-component/OnboardButton";
import NotNullCheck from "../../util/NotNullCheck";
import EndUseAgreementTTNETCheckbox from "../../component/custom/EndUseAgreementTTNETCheckbox";
import LoginStateManager from "../../util/LoginStateManager";
import VerifyTypeEnum from "../../enum/VerifyTypeEnum";
import OnboardTabsInner from "../../component/base/onboard-tabs-inner-component/OnboardTabsInner";
import {isEmpty, isSeatNumber} from "../../util/Validation";
import {setSimulationNumber} from '../../util/SimulationManager';
import {useRecoilValue} from 'recoil';
import {informationAtom} from '../../store/InformationStore';
import {restartWarningDialogPleaseCheckYourDataUsage} from '../../store/UserStore';

const LoginWithFlightInformation = (props) => {
    const {t, i18n, handleInformation} = props.props;
    const simulationNumber = setSimulationNumber();
    const isSimulation = setSimulationNumber();
    const information = useRecoilValue(informationAtom);

    const [error, setError] = useState(null);

    const {processLogin, processLoginTicket} = new LoginStateManager(props.props, VerifyTypeEnum.SEAT_OR_TICKET);

    const validation = () => {
        if (NotNullCheck(control())) {
            if (selectOption === 1) {
                processLogin(surname, seatNumber);
            } else {
                processLoginTicket(ticketNumber);
            }
        }
    }

    useEffect(() => {
        if (information.simulationNumber === 12) {
            setSurname("AHMAD");
            setSeatNumber("1A");
            setApprove(true);
            restartWarningDialogPleaseCheckYourDataUsage();
        }
    }, [information]);

    const control = () => {
        let valid = {
            surname: (surname == null || surname.length === 0) ? t('error.empty_surname') : null,
            seatNumber: (seatNumber == null || seatNumber.length === 0) ? t('error.empty_seat_number') : null,
            ticketNumber: (ticketNumber == null || ticketNumber.length === 0) ? t('error.empty_ticket_number') : null,
            approve: (approve == null || !approve) ? t('error.empty_approve') : null
        };
        if (seatNumber != null && seatNumber.length > 0) {
            valid.seatNumber = /^[\da-z]+$/i.test(seatNumber) ? null : t('error.valid_seat_number');
        }
        if (ticketNumber != null && ticketNumber.length > 0) {
            valid.ticketNumber = ticketNumber.length === 13 ? null : t('error.valid_ticket_number');
        }
        if (selectOption === 1) {
            valid.ticketNumber = null;
        } else {
            valid.surname = null;
            valid.seatNumber = null;
        }
        setError(valid);
        return valid;
    }

    useEffect(() => {
        if (error !== null) {
            control();
        }
    }, [i18n.language])

    const handleSelectOption = (e) => {
        setSelectOption(e);
        setError(null);
        setSeatNumber(null);
        setSurname(null);
        setTicketNumber(null);

        handleInformation("flightInformationType_" + e);
        if (e === 2) {
            if (isSimulation) {
                setTicketNumber("1234567890123");
                setApprove(true);
            }
            simulationNumber(3, 3);
        }
    }

    const [selectOption, setSelectOption] = useState(1);
    const [surname, setSurname] = useState(null);
    const [seatNumber, setSeatNumber] = useState(null);
    const [ticketNumber, setTicketNumber] = useState(null);
    const [approve, setApprove] = useState(null);

    return (
        <div>

            <OnboardTabsInner
                defaultActiveTab={1}
                onChange={(e) => handleSelectOption(e)}
                tabs={[
                    {label: t('login.seat_number_option'), value: 1},
                    {label: t('login.ticket_number_option'), value: 2}]}
            />

            {selectOption === 1 && (
                <>
                    <OnboardInput placeholder={t('login.seat_number')} onChange={(e) => setSeatNumber(e)}
                                  error={error?.seatNumber} hint
                                  validation={isSeatNumber(seatNumber, t('error.valid_seat_number'), t('error.empty_seat_or_ticket_number'))}
                                  mask={{
                                      mask: "9{1,2}a",
                                      definitions: {"a": {casing: "upper", validator: "[A-Ka-k]"}}
                                  }}
                                  value={seatNumber}/>
                    <div className="h-8"/>
                    <OnboardInput placeholder={t('login.surname')}
                                  onChange={(e) => setSurname(e)}
                                  error={error?.surname}
                                  upperAndEng length={30}
                                  value={surname}/>
                </>
            )}

            {selectOption === 2 && (
                <>
                    <OnboardInput placeholder={t('login.ticket_number')} onChange={(e) => setTicketNumber(e)}
                                  error={error?.ticketNumber}
                                  validation={isEmpty(ticketNumber, t('error.empty_ticket_number'))}
                                  mask={{mask: "9{1,13}"}}
                                  value={ticketNumber}/>
                </>
            )}

            <div className="h-20"/>

            <EndUseAgreementTTNETCheckbox value={approve}
                                          error={error?.approve}
                                          onChange={(e) => setApprove(e)}
            />

            <div className="h-16"/>

            <OnboardButton label={t('login.login_btn')} onClick={() => validation()}/>

        </div>
    );
};

export default LoginWithFlightInformation;

